import DelaySignings from './delay-signings-view'

export default DelaySignings
